import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationStyles = createGlobalStyle`
  @font-face {
      font-family: 'CustomArial';
      src: url(${CustomArial});
  }    
  .generated-images-holder-var16 {
    /* position: absolute; */
    bottom: 100%;
    right: 100%;
    width: 700px;
  }
  .image-holder-var16 {
    width: 100%;
    position: relative;
  }
  .top-text-var16 {
    width: 100%;
    background-color: white;
    padding: 24px 33px;
    font-size: 41px;
    line-height: 1.25;
    color: #1C2327;
    font-family: CustomArial;
  }
  .bottom-text-var16 {
    position: absolute;
    bottom: 32px;
    margin: auto;
    left: 0;
    right: 0;
    font-size: 36px;
    line-height: 1.15;
    letter-spacing: 0.1px;
    color: #f3d400;
    font-weight: 700;
    text-align: center;
    font-family: CustomArial;
    z-index: 1;
    text-shadow: 
    -3px -3px 0 black,
     3px -3px 0 black,
    -3px  3px 0 black,
     3px  3px 0 black,
    -3px  0   0 black,
     3px  0   0 black,
     0   -3px 0 black,
     0    3px 0 black;
    p {
      display: inline-block;
      margin: 0;
    }
  }
  .full-image-var16 {
    width: 100%;
    height: auto;
    display: block;
  }

  .watermark-var16 {
    position: absolute;
    bottom:10px;
    right: 20px;
    z-index: 1;
  }
  .actual-photo-var16 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 47px;
  }
  .actual-photo-var16--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationStyles;
